import thumbnail_4 from '../sanaideeAdminPanel/thumbnail.png';

import image0 from '../sanaideeAdminPanel/0.png';
import image1 from '../sanaideeAdminPanel/1.png';
import image2 from '../sanaideeAdminPanel/2.png';
import image3 from '../sanaideeAdminPanel/3.png';
import image4 from '../sanaideeAdminPanel/4.png';
import image5 from '../sanaideeAdminPanel/5.png';


export const SanaideeAdminPanel = {
  id: 7,
  type: 'web',
  thumbnails: [thumbnail_4],
  screens: [image0, image1, image2, image3, image4, image5],
  title: 'Sanaidee – Admin Panel for Delivery Operations in Saudi Arabia',
  intro:
    "The Sanaidee Admin Panel is a web-based dashboard built for internal teams to manage and monitor the courier ecosystem in Saudi Arabia. It provides full visibility into orders, user activity, driver documents, vehicle verifications, and platform performance — ensuring everything runs securely and efficiently behind the scenes.",
  features: [
    {
      title: "Comprehensive Dashboard & Live Statistics",
      description:
        "View real-time data on active deliveries, driver activity, earnings, and order statuses. Gain insights through charts and metrics to monitor daily performance and trends."
    },
    {
      title: "Driver & Company Verification System",
      description:
        "Admins can review submitted documents like IDs, licenses, and vehicle registrations. Easily approve, reject, or request resubmissions — keeping the platform compliant and secure."
    },
    {
      title: "Order Management Interface",
      description:
        "Track all orders placed across the platform with status filters. View delivery routes, timestamps, and driver assignments. Reassign orders or intervene in special cases when necessary."
    },
    {
      title: "User Management Tools",
      description:
        "Access detailed profiles for customers and drivers. Manage roles, ban suspicious accounts, reset passwords, and view communication history when resolving disputes."
    },
    {
      title: "Vehicle Oversight & Audit Logs",
      description:
        "Monitor registered vehicles with details like make, model, capacity, and assigned drivers. All admin actions are logged for accountability and auditing."
    },
    {
      title: "Support Ticket Handling & In-App Chat Logs",
      description:
        "Respond to user-reported issues through a centralized support system. View chat transcripts between users and drivers to resolve problems faster and fairly."
    },
    {
      title: "Permissions & Role-Based Access Control",
      description:
        "Set up multiple admin roles with different levels of access (e.g., support agent, verifier, supervisor). Ensure each team member sees only the data relevant to their role."
    }
  ],
  conclusion:
    "The Sanaidee Admin Panel is the operational backbone of the courier platform — giving the internal team all the tools they need to verify drivers, track deliveries, and support users across Saudi Arabia. Built for performance, security, and scalability, it ensures smooth delivery operations every day."
};
